import React, { useRef, useState } from 'react';
import { Stack, TextField } from '@origin-digital/ods-core';
import { useAddressSearch } from './useAddressSearch';
import { IOriginAddressMeter } from '../fetchers';
import { AddressMeterSearch } from './AddressMeterSearch';

export interface INMISearch {
  endpoint: string;
  onConfirm: (address: IOriginAddressMeter) => void;
  isDedicatedNmiSearch?: boolean;
}

export const AddressNMISearch: React.FC<INMISearch> = ({
  endpoint,
  onConfirm,
  isDedicatedNmiSearch = false,
}) => {
  const {
    data,
    inputError,
    error,
    isSearching,
    isConfirmEnabled,
    validate,
    search,
    resetSearch,
    config,
  } = useAddressSearch(endpoint, 'NMI');

  const [value, setValue] = useState('');
  const inputRef = useRef<HTMLInputElement | null>(null);

  return (
    <Stack space="large">
      <TextField
        inputRef={inputRef}
        id="nmi-search"
        label={config.label}
        error={!!inputError}
        value={value}
        helperText={inputError ? inputError : 'Must be 10 or 11 characters long'}
        onBlur={({ target }) => validate(target.value)}
        onChange={({ target }) => setValue(target.value)}
        maxLength={config.maxLength}
        hideHelperTextSpace={!!error || isConfirmEnabled}
        endIcon={data && 'success'}
      />
      <AddressMeterSearch
        addressResult={data as IOriginAddressMeter}
        error={error}
        inputRef={inputRef}
        isConfirmEnabled={isConfirmEnabled}
        isLoading={isSearching}
        meterType="NMI"
        onConfirm={onConfirm}
        onResetSearch={resetSearch}
        onSearch={() => search(value)}
        isDedicatedNmiSearch={isDedicatedNmiSearch}
      />
    </Stack>
  );
};
